"use client";

import { m as motion, useReducedMotion } from "framer-motion";

export function HeroMesh() {
  const prefersReduced = useReducedMotion();

  return (
    <motion.div
      aria-hidden
      className="pointer-events-none absolute -inset-[10%] -z-20"
      style={{
        background: [
          "radial-gradient(60% 50% at 20% 30%, rgba(30,63,232,0.35) 0%, transparent 60%)",
          "radial-gradient(50% 40% at 85% 70%, rgba(34,211,238,0.18) 0%, transparent 55%)",
          "radial-gradient(70% 60% at 50% 100%, rgba(59,126,255,0.22) 0%, transparent 65%)",
        ].join(", "),
        filter: "blur(40px) saturate(130%)",
      }}
      animate={
        prefersReduced
          ? undefined
          : {
              x: ["0%", "-3%", "2%"],
              y: ["0%", "2%", "-2%"],
              scale: [1, 1.05, 1.02],
            }
      }
      transition={{
        duration: 24,
        ease: "easeInOut",
        repeat: Infinity,
        repeatType: "reverse",
      }}
    />
  );
}
